query AnalyticsUsersByEmailCampaign($filter: AnalyticsUsersFilterInput!, $limit: Int) {
  analyticsUsers(filter: $filter) {
    usersByEmailCampaign(limit: $limit) {
      automationId
      title
      users
    }
  }
}
